import { extractRawDateYear } from 'routes/HumanResourcesModule/Simulation/helpers/dataHelpers';
import { EchelonHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/EchelonsOverview/helpers/types';

/**
 * @param firstYear: the year of the simulation start date
 * @param lastYear : the year of the simulation end date
 * @param t: translator
 * @returns the non formatted string containing the echelon hypothesis info
 *
 * If the simulation is on 2 years (budget proposition), we need to display echelon count
 * info for both years, else only the firstYear is needed
 */
export const getEchelonResume = (
    echelonHypotheses: EchelonHypothesis[],
    firstYear: number,
    lastYear: number,
    t: TranslationT,
) => {
    const countFirstYear = echelonHypotheses.filter(
        (hyp) => extractRawDateYear(hyp.startDate) === firstYear,
    ).length;
    const firstYearTranslation = t(
        'humanResources.simulation.echelonRaiseResume',
        {
            count: countFirstYear,
            year: firstYear,
        },
    );
    if (lastYear > firstYear) {
        const countLastYear = echelonHypotheses.filter(
            (hyp) => extractRawDateYear(hyp.startDate) === lastYear,
        ).length;
        return `${firstYearTranslation} & ${t(
            'humanResources.simulation.echelonRaiseResume',
            {
                count: countLastYear,
                year: lastYear,
            },
        )} - `;
    }
    return `${firstYearTranslation} - `;
};
